<template>
  <teleport to="body">
    <div v-if="show" class="backdrop"></div>
    <transition name="dialog">
      <dialog open v-if="show" >   
        <div class="header">
            <div class="btn">
                <base-button-sm mode="darkblue" @click="$emit('close')">{{switchConfirmMent()}}</base-button-sm>
            </div>
            <div class="title">
                <strong>[ {{toNic}}] </strong> 님과 1:1 채팅        
            </div>
        </div>    
        <div class="chat_body" >                
            <iframe :src="`/m_chat/${chat_roomId}`" frameborder="0" width="100%" height="100%"></iframe>
        </div>     
      </dialog>
    </transition>
  </teleport>
</template>

<script>
import { auth } from '@/components/mixins/auth.js';
export default {
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: false,
        },
        fixed: {
            type: Boolean,
            required: false,
            default: false,
        },
        apply:{
            type: String,
            required: false,        
        },
        cancel:{
            type: String,
            required: false,     
        },  
        chat_roomId:{
            default:'',
        }  
    },
    mixins:[
        auth
    ],
    components:{
        
    },
    emits: ["close"],
    computed:{
        toNic(){
           return this.$store.getters['sets/getMtm'].find((mtm)=>mtm.room === this.chat_roomId).nic;
        }
    },
    methods: {
        switchConfirmMent(){
            if(this.cancel)
            {
                return this.cancel;
            }else{
                return '닫기';
            }
        },
        tryApply() {
            if (this.fixed) {
                return;
            }
            this.$emit("apply");
        },
        tryClose() {
            if (this.fixed) {
                return;
            }
            this.$emit("close");
        },
        tryClose2() {      
            this.$emit("fixedclose");  
            this.$emit("close");   
        },

  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 21;
}
.header{
    height:40px;
    display: flex;
    .btn{
        height:30px;
        display: flex;
        margin-top:5px;    
        width:80px;
    }
    .title{
        line-height: 40px;
        padding-left:20px;
       
    }
}
.chat_body{
    height: calc(100% - 40px);
}
dialog {
  position: fixed;
  top: 160px;
  left: 2%;
  width: 96%;
  height: calc(100vh - 165px);
  z-index: 22;
  border: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
}
.mobile_dialog{
  width:90% !important;
  left: 5%;
  top: 10vh;
}
.mobile_dialog .btn{
  width:50%;
}
menu {
  padding: 1rem;
  display: flex;
  justify-content: center;
  margin: 0;

}
menu .btn
{
  width:20%;padding:0 10px;
  height:30px;
}


menu {
  padding: 1rem;
  display: flex;
  justify-content: center;
  margin: 0;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.dialog-enter-active {
  transition: all 0.3s ease-out;
}

.dialog-leave-active {
  transition: all 0.3s ease-in;
}

.dialog-enter-to,
.dialog-leave-from {
  opacity: 1;
  transform: translateY(0);
}

@media (min-width: 768px) {
  dialog {
    left: calc(50% - 20rem);
    width: 40rem;
  }
}

</style>
